/* The pages script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO inner pages: the few behaviours the inner pages add to web.js.
   1. Today's date on the thank-you page's status row.
   2. The gallery viewer: a tile opens its photograph on a strip of the group that swipes natively; arrows, the keyboard and a
      tap move it too.
   3. One pin on the Dealer Locator's grey map, for the contact page and Our Story.
   4. The chase: a rail that turns orange as the page scrolls down it. Straight everywhere ([data-chase]);
      Our Story alone threads it through its milestones as one curve ([data-trail]).
   5. The phone bar on a page whose form sits right under the hero ([data-sticky-after]).
   6. Tabs ([data-tabs]): the fleet page's working spec; the packages' classes, which a vehicle grid set to follow them
      ([data-follow]) takes up.
   7. The gallery's vehicles ([data-gnav]): a line of chips under the header that marks the vehicle in view.
   8. A form sent: on ?contact_posted=true the contact form's sent state stands in the form's place, as the store draws it. */
(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoPages) return;
  root.dataset.xgoPages = '1';

  /* ---------- today's date ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  [].forEach.call(root.querySelectorAll('[data-today]'), function (el) {
    var d = new Date();
    el.textContent = d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  });

  /* ---------- the phone bar on a page with no hero: tied to the opening leaving the viewport ---------- */
  var bar = root.querySelector('[data-sticky]'), opening = root.querySelector('[data-open]');
  if (bar && opening && !root.querySelector('.ti-hero') && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      var gone = !e[0].isIntersecting;
      bar.classList.toggle('is-on', gone);
      bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
    }, { threshold: 0 }).observe(opening);
  }

  /* ---------- the phone bar on a page whose form sits right under the hero: it stays away while the hero or the form
     is on screen, so it never covers the form it points to ---------- */
  var barAfter = root.querySelector('[data-sticky-after]');
  if (barAfter && 'IntersectionObserver' in window) {
    var seen = {}, watch = [root.querySelector('.ti-hero'), root.querySelector(barAfter.getAttribute('data-sticky-after'))].filter(Boolean);
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen[watch.indexOf(e.target)] = e.isIntersecting; });
      var on = !watch.some(function (w, i) { return seen[i]; });
      barAfter.classList.toggle('is-on', on);
      barAfter.setAttribute('aria-hidden', on ? 'false' : 'true');
    }, { threshold: 0.05 });
    watch.forEach(function (w) { sio.observe(w); });
  }

  /* ---------- a form sent: the review file draws what the store draws after a message is sent (contact_posted=true): the
     sent state in the form's place, the form's own head above it ---------- */
  var sent = root.querySelector('template[data-form-sent]');
  if (sent && /[?&]contact_posted=true/.test(location.search)) {
    var sentForm = root.querySelector('.ti-form');
    if (sentForm) { sentForm.textContent = ''; sentForm.appendChild(sent.content.cloneNode(true)); }
  }

  /* ---------- tabs: three views of one subject. Arrow keys move between them, as the pattern asks. A tab that names a
     class of vehicle (data-class) tells every vehicle grid set to follow the tabs (data-follow) which class is on: the grid
     writes it on itself, its stylesheet shows that class's band with the mystery ute, and its head takes that class's words
     (data-class-only). The focus stays where it is. Without the script both bands show under the first class's head ---------- */
  var follow = function (cls) {
    [].forEach.call(root.querySelectorAll('[data-follow]'), function (f) {
      f.setAttribute('data-class', cls);
      [].forEach.call(f.querySelectorAll('[data-class-only]'), function (x) { x.hidden = x.getAttribute('data-class-only') !== cls; });
    });
  };
  [].forEach.call(root.querySelectorAll('[data-tabs]'), function (box) {
    var tabs = [].slice.call(box.querySelectorAll('[role="tab"]'));
    var pick = function (t, focus) {
      tabs.forEach(function (x) {
        var on = x === t, panel = document.getElementById(x.getAttribute('aria-controls'));
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
      if (t.getAttribute('data-class')) follow(t.getAttribute('data-class'));
      if (focus) t.focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); pick(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true); }
      });
    });
    var on = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
    if (on && on.getAttribute('data-class')) follow(on.getAttribute('data-class'));
  });

  /* ---------- gallery viewer ----------
     A strip of the group's photographs, one to a frame, scroll-snapped: a finger swipes it as it swipes anything on a phone, with
     the browser's own momentum and snap, and a trackpad does the same. The arrows, the arrow keys and a tap on the photograph
     move it too, and the caption counts where it is. On a phone a photograph takes the screen's width as a square; a drawing
     (data-view-fit="whole") is always shown whole. The Playbook draws one in place on the same strip (data-view-inline).
     The strip runs on (Dan, 14 October: a gallery never stops at its end). A copy of the last photograph stands before the first
     and a copy of the first after the last (loop, below); a swipe or a step that comes to rest on a copy is moved, with no
     animation, to the photograph it copies, which looks the same in the same place, so past the last comes the first and before
     the first the last, in either direction, with no seam. */
  var vesc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
  var loop = function (track) {
    if (track.children.length < 2) return;
    var a = track.firstElementChild.cloneNode(true), z = track.lastElementChild.cloneNode(true);
    [a, z].forEach(function (c) { c.setAttribute('data-copy', ''); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('id'); });
    track.appendChild(a);
    track.insertBefore(z, track.firstElementChild);
  };
  var strip = function (track, onAt) {
    var at = 0, aim = -1, ticking = false, rest = 0;
    var w = function () { return track.clientWidth || 1; };
    var off = function () { return track.firstElementChild && track.firstElementChild.hasAttribute('data-copy') ? 1 : 0; };
    var count = function () { return track.children.length - 2 * off(); };
    var to = function (p) { try { track.scrollTo({ left: p * w(), behavior: 'instant' }); } catch (e) { track.scrollLeft = p * w(); } };
    /* at rest on a copy: to the photograph it copies, in the same place */
    var home = function () {
      if (!off()) return;
      var p = Math.round(track.scrollLeft / w()), n = count();
      if (p <= 0) to(n); else if (p >= n + 1) to(1);
    };
    track.addEventListener('scroll', function () {
      clearTimeout(rest); rest = setTimeout(home, 140);   /* rest, where a browser has no scrollend yet */
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var n = count();
        if (!n) return;
        var i = ((Math.round(track.scrollLeft / w()) - off()) % n + n) % n;   /* a copy counts as the photograph it shows */
        if (aim >= 0) { if (i !== aim) return; aim = -1; }
        if (i !== at) { at = i; onAt(i); }
      });
    }, { passive: true });
    track.addEventListener('scrollend', home);
    ['pointerdown', 'wheel', 'keydown'].forEach(function (ev) { track.addEventListener(ev, function () { aim = -1; }, { passive: true }); });
    return {
      go: function (i, instant) {
        var n = count(), o = off();
        if (!n) return;
        /* with the copies, one step past either end goes on to the copy there, and comes to rest at home */
        var p = o && !instant && (i === -1 || i === n) ? i + 1 : (i + n) % n + o;
        i = (i + n) % n;
        aim = instant ? -1 : i; at = i; onAt(i);
        if (instant || reduce) { to(p); home(); } else track.scrollTo({ left: p * w(), behavior: 'smooth' });
      },
      at: function () { return at; }
    };
  };
  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    p: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    n: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };
  var tiles = [].slice.call(root.querySelectorAll('[data-view-src]'));
  if (tiles.length) {
    var view = document.createElement('div');
    view.className = 'ti-view';
    view.setAttribute('role', 'dialog');
    view.setAttribute('aria-modal', 'true');
    view.setAttribute('aria-label', 'Photograph viewer');
    view.innerHTML = '<div class="ti-view__track" tabindex="-1"></div>' +
      '<button type="button" class="ti-view__b ti-view__x" aria-label="Close">' + ICON.x + '</button>' +
      '<button type="button" class="ti-view__b ti-view__p" aria-label="Previous photograph">' + ICON.p + '</button>' +
      '<button type="button" class="ti-view__b ti-view__n" aria-label="Next photograph">' + ICON.n + '</button>' +
      '<p class="ti-label ti-view__cap" aria-live="polite"></p>';
    var host = document.createElement('div'); host.className = 'ti'; document.body.appendChild(host); host.appendChild(view);
    var track = view.querySelector('.ti-view__track'), cap = view.querySelector('.ti-view__cap');
    var set = [], opener = null;
    var s = strip(track, function (i) { if (set[i]) cap.textContent = (set[i].getAttribute('data-view-group') || '') + '  ' + (i + 1) + ' / ' + set.length; });
    var open = function (t) {
      var g = t.getAttribute('data-view-group');
      set = tiles.filter(function (x) { return x.getAttribute('data-view-group') === g; });
      opener = t;
      view.classList.toggle('is-whole', t.getAttribute('data-view-fit') === 'whole');
      track.innerHTML = set.map(function (x) {
        return '<figure class="ti-view__s"><img src="' + vesc(x.getAttribute('data-view-src')) + '" alt="' + vesc(x.getAttribute('aria-label')) + '" decoding="async"></figure>';
      }).join('');
      loop(track);
      view.classList.add('is-on');
      document.documentElement.style.overflow = 'hidden';
      s.go(set.indexOf(t), true);
      view.querySelector('.ti-view__x').focus();
      /* the viewer is a step in the history: the browser's back and a phone's back gesture close it and leave the reader on
         the page where they were. The page's address does not change (a file opened from disk allows no other) */
      try { if (!(history.state && history.state.xgView)) history.pushState({ xgView: true }, ''); } catch (err) {}
    };
    var shut = function () {
      view.classList.remove('is-on');
      document.documentElement.style.overflow = '';
      track.innerHTML = '';
      if (opener) opener.focus();
    };
    var close = function () {
      if (!view.classList.contains('is-on')) return;
      if (history.state && history.state.xgView) history.back();   /* the step back closes it (popstate, below) */
      else shut();
    };
    window.addEventListener('popstate', function () { if (view.classList.contains('is-on')) shut(); });
    tiles.forEach(function (t) { t.addEventListener('click', function () { open(t); }); });
    view.addEventListener('click', function (e) {
      if (e.target.closest('.ti-view__x')) return close();
      if (e.target.closest('.ti-view__p')) return s.go(s.at() - 1);
      if (e.target.closest('.ti-view__n') || e.target.closest('.ti-view__s img')) return s.go(s.at() + 1);
      if (e.target === view || e.target === track || e.target.classList.contains('ti-view__s')) close();   /* around the photograph */
    });
    document.addEventListener('keydown', function (e) {
      if (!view.classList.contains('is-on')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') { e.preventDefault(); s.go(s.at() - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); s.go(s.at() + 1); }
    });
  }
  [].forEach.call(root.querySelectorAll('[data-view-inline]'), function (v) {   /* the Playbook's, drawn in place */
    var tr = v.querySelector('.ti-view__track'), c = v.querySelector('.ti-view__cap');
    var n = tr ? tr.children.length : 0, g = v.getAttribute('data-view-inline');
    if (!n) return;
    loop(tr);
    var si = strip(tr, function (i) { if (c) c.textContent = g + '  ' + (i + 1) + ' / ' + n; });
    si.go(0, true);   /* on the first photograph, past the copy before it */
    v.addEventListener('click', function (e) {
      if (e.target.closest('.ti-view__p')) si.go(si.at() - 1);
      else if (e.target.closest('.ti-view__n') || e.target.closest('.ti-view__s img')) si.go(si.at() + 1);
    });
  });

  /* ---------- the gallery's vehicles follow the reader ----------
     The jump list holds under the header and steps away on a phone going down (web.css and web.js: a line that holds under the
     header). The vehicle in view is marked, as the article's contents mark theirs, and on a line longer than the screen the
     marked chip is brought into view. A chip tapped is marked at once, and the line holds still (data-hold) while the page
     travels to its vehicle, so the reader stays on what they tapped. */
  [].forEach.call(root.querySelectorAll('[data-gnav]'), function (gnav) {
    var nav = gnav.querySelector('nav');
    if (!nav) return;
    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    var groups = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var on = -1, hold = false, settle = null;
    var bring = function (a) {
      if (nav.scrollWidth <= nav.clientWidth) return;
      nav.scrollTo({ left: Math.max(0, a.offsetLeft - (nav.clientWidth - a.offsetWidth) / 2), behavior: reduce ? 'auto' : 'smooth' });
    };
    var mark = function (i) {
      if (i === on) return;
      on = i;
      links.forEach(function (a, j) { if (j === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      if (i >= 0) bring(links[i]);
    };
    var spy = function () {
      var line = gnav.getBoundingClientRect().bottom + 24, i = -1;
      for (var k = 0; k < groups.length; k++) if (groups[k] && groups[k].getBoundingClientRect().top <= line) i = k;
      mark(i);
    };
    var release = function () { hold = false; gnav.removeAttribute('data-hold'); spy(); };
    links.forEach(function (a, i) {
      a.addEventListener('click', function () {
        hold = true; gnav.setAttribute('data-hold', ''); gnav.classList.remove('is-away'); mark(i);
        clearTimeout(settle); settle = setTimeout(release, 1200);   /* in case the page does not move at all */
      });
    });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (hold) { clearTimeout(settle); settle = setTimeout(release, 160); return; }
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; spy(); });
    }, { passive: true });
    spy();
  });

  /* ---------- one pin on the drawn map: the dealer's region alone (data-pin names its region page, a pin's data-region its
     own: the pin itself opens the locator; the theme draws one pin to begin with, and this keeps the review file honest) ---------- */
  [].forEach.call(root.querySelectorAll('[data-mapbox]'), function (box) {
    var keep = box.getAttribute('data-pin') || '';
    if (!keep) return;
    [].forEach.call(box.querySelectorAll('.ti-map__pin'), function (p) {
      if (p.getAttribute('data-region') !== keep) p.remove();
    });
  });

  /* ---------- the chase ----------
     How far down a block the reader is: 0 when its top reaches a little past the middle of the window, 1 when its
     foot does. One scroll listener, one frame at a time, for every rail on the page. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rails = [];
  var progress = function (el) {
    var r = el.getBoundingClientRect();
    var p = (window.innerHeight * 0.55 - r.top) / (r.height || 1);
    return p < 0 ? 0 : (p > 1 ? 1 : p);
  };

  /* straight: the list's own rail; a second line in orange grows down it, and a ring fills as the line reaches it.
     The orange stops at the last ring: what comes after the last step is the reader's move, not ours. */
  [].forEach.call(root.querySelectorAll('[data-chase]'), function (list) {
    var items = [].slice.call(list.children);
    if (!items.length) return;
    list.classList.add('has-chase');
    var ring = function (li) { return li.offsetTop + (parseFloat(window.getComputedStyle(li).paddingTop) || 0) + 12; };
    rails.push(function () {
      var span = ring(items[items.length - 1]), top = list.getBoundingClientRect().top;
      var p = reduce ? 1 : (window.innerHeight * 0.6 - top) / (span || 1);
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      var reach = p * span;
      list.style.setProperty('--chase', (reach / (list.offsetHeight || 1)).toFixed(4));
      items.forEach(function (li) { li.classList.toggle('is-lit', ring(li) <= reach + 1); });
    });
  });

  /* curved: Our Story. One curve threaded through every milestone, measured from the laid-out milestones so it
     always meets the rings, however many there are and however tall they run. */
  var tl = root.querySelector('[data-trail]');
  if (tl && document.createElementNS) {
    var NS = 'http://www.w3.org/2000/svg';
    var nodes = [].slice.call(tl.children);
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'ti-tl__trail');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('preserveAspectRatio', 'none');
    var threads = document.createElementNS(NS, 'g');
    var base = document.createElementNS(NS, 'path'); base.setAttribute('class', 'is-base');
    var chase = document.createElementNS(NS, 'path'); chase.setAttribute('class', 'is-chase');
    svg.appendChild(threads); svg.appendChild(base); svg.appendChild(chase);
    tl.appendChild(svg);   /* last, so the milestones keep their odd and even places */
    tl.classList.add('has-trail');
    var len = 0, ys = [];
    /* Catmull-Rom through the points, written as cubic beziers: a continuous curve with no kink at a milestone */
    var smooth = function (pts) {
      var d = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || pts[i + 1];
        d += 'C' + (p1.x + (p2.x - p0.x) / 6).toFixed(1) + ',' + (p1.y + (p2.y - p0.y) / 6).toFixed(1) + ' ' +
                   (p2.x - (p3.x - p1.x) / 6).toFixed(1) + ',' + (p2.y - (p3.y - p1.y) / 6).toFixed(1) + ' ' +
                   p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
      }
      return d;
    };
    var update = function () {
      if (!len) return;
      var p = reduce ? 1 : progress(tl);
      chase.style.strokeDashoffset = (len * (1 - p)).toFixed(1);
      var at = chase.getPointAtLength(len * p).y;
      nodes.forEach(function (n, i) { n.classList.toggle('is-lit', ys[i] <= at + 1); });
    };
    var build = function () {
      var w = tl.clientWidth, h = tl.offsetHeight;
      if (!w || !h) return;
      var wide = window.matchMedia('(min-width: 900px)').matches;
      var cx = wide ? w / 2 : 14, amp = wide ? Math.min(44, w * 0.04) : 8;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      var pts = [], lines = '';
      ys = [];
      nodes.forEach(function (n, i) {
        var right = wide ? n.offsetLeft > w / 4 : i % 2 === 1;
        var x = cx + (right ? 1 : -1) * amp * (0.62 + ((i * 37) % 40) / 100);   /* the swing varies, so the line never settles into an obvious repeat */
        var y = n.offsetTop + 8.5;
        pts.push({ x: x, y: y }); ys.push(y);
        n.style.setProperty('--node-x', (x - n.offsetLeft - 8).toFixed(1) + 'px');   /* half the 16 px ring */
        var edge = wide ? (right ? n.offsetLeft + 64 : n.offsetLeft + n.offsetWidth - 64) : n.offsetLeft + 44;
        lines += '<line x1="' + x.toFixed(1) + '" y1="' + y.toFixed(1) + '" x2="' + edge.toFixed(1) + '" y2="' + y.toFixed(1) + '"/>';
      });
      /* it enters and leaves on the same line as the first and last milestone, so it never hooks back at an end */
      pts.unshift({ x: pts[0].x, y: -30 });
      pts.push({ x: pts[pts.length - 1].x, y: h });
      var d = smooth(pts);
      base.setAttribute('d', d); chase.setAttribute('d', d);
      threads.innerHTML = lines;
      len = chase.getTotalLength();
      chase.style.strokeDasharray = len;
      update();
    };
    rails.push(update);
    window.addEventListener('resize', build, { passive: true });
    window.addEventListener('load', build);
    if ('ResizeObserver' in window) new ResizeObserver(build).observe(tl);
    build();
  }

  if (rails.length) {
    var ticking = false;
    var run = function () { rails.forEach(function (f) { f(); }); ticking = false; };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(run); } }, { passive: true });
    window.addEventListener('resize', run, { passive: true });
    run();
  }
})();
